import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { message } from 'antd';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const useWarnToastDetector = (idleTime = 1140) => {
  const idleTimeout = 1000 * idleTime;
  const [isIdle, setIdle] = useState(false);
  const intlMessage = useFormatMessage();

  const handleIdle = () => {
    setIdle(true);
    message.warning(intlMessage({ id: 'auth.willBeLogoutWarning' }), 58);
  };
  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    onIdle: handleIdle,
    debounce: 500,
  });
  return {
    isIdle,
    setIdle,
    idleTimer,
  };
};
